import { clsx, type ClassValue } from 'clsx';
import dayjs from 'dayjs';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * 从 HTML 字符串中提取纯文本，去除 p、br 等标签
 * @param html - 可能包含 HTML 的字符串
 * @returns 纯文本
 */
export function extractText(html: string | undefined): string {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').trim();
}

/**
 * 格式化秒级时间戳
 * @param time - 秒级时间戳（字符串或数字）
 * @param format - dayjs 格式，默认 YYYY-MM-DD
 * @returns 格式化后的日期字符串
 */
export function formatTime(time: string | number | undefined | null, format = 'YYYY-MM-DD'): string {
  if (!time) return '';
  return dayjs.unix(Number(time)).format(format);
}
